import PPaddMessageManagementForGF from "./PPaddMessageManagementForGF";
document.addEventListener('DOMContentLoaded', ()=> {
    const ppMessageManagement =  new PPaddMessageManagementForGF('#gform_16');
    ppMessageManagement.setElements();
});

